export default __webpack_public_path__ + "static/media/ant2.04c25ff5.jpg";